module.exports = __webpack_public_path__ + "static/media/random.962af7bd.svg";